import React$1 from 'react';

const Tiktok = () => /*#__PURE__*/React$1.createElement("svg", {
  width: "40",
  height: "40",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 2500 2500"
}, /*#__PURE__*/React$1.createElement("path", {
  d: "M1250 0C559.6 0 0 559.6 0 1250s559.6 1250 1250 1250 1250-559.6 1250-1250S1940.4 0 1250 0zm714.9 1090.7h-.2c-13.7 1.3-27.4 2-41.1 2.1-149.9 0-289.8-75.3-372.3-200.4-.2-.4-.8-.2-.8.2v681.8c0 296.4-251.7 532.3-547.2 509.5-261.8-20.2-467.9-239.1-467.9-506 0-280.3 227.2-507.6 507.6-507.6 10.5 0 20.7.9 30.9 1.6.2 0 .4.2.4.5v249.2c0 .3-.2.5-.5.5-10.2-1.2-20.3-3.1-30.9-3.1-143.1 0-259 116-259 259s116 259 259 259c143.1 0 269.5-112.7 269.5-255.8l2.5-1165.9c0-.3.2-.5.5-.5h238.4c.2 0 .4.2.4.4 22.7 214.2 195.5 381.6 410.3 397.5.2 0 .4.2.4.5v277.5z",
  fill: "#ff005f"
}));

export default Tiktok;
